import PropTypes from 'prop-types';
import colors from '../../util/colors.js';

var propTypes = {
    color: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    duration: PropTypes.number,
    disabled: PropTypes.bool,
    isToast: PropTypes.bool,
};
var defaultProps = {
    color: colors.black,
    disabled: false,
    duration: 4000,
};

export { defaultProps, propTypes };
